import { StaticImage } from "gatsby-plugin-image"
import React, { useContext } from "react"
import styled from "styled-components"
import ContentDiv from "../components/contentDiv"
import DownloadList from "../components/downloadList"
import FirstSection from "../components/firstSection"
import Layout from "../components/layout"
import PageImage from "../components/pageImage"
import PageSection from "../components/pageSection"
import { BackendContext } from "../services"
import { tablet, laptop } from "../util/mediaQueries"
import { Media } from "gatsby-plugin-fresnel"
import SEO from "../components/seo"
import { FiDownload } from "react-icons/fi"

const RootDiv = styled.div`
  display: flex;
  flex-direction: row;
`

const DownloadDiv = styled.div`
  width: 100%;
`

const Downloads = () => {
  const { documents } = useContext(BackendContext)

  return (
    <Layout>
      <PageImage>
        <Media greaterThanOrEqual="md">
          <StaticImage
            src="../images/Titelbild_Downloads_PC.jpeg"
            quality={95}
            formats={["auto", "webp", "avif"]}
            alt="Image"
            objectFit="contain"
            layout="fullWidth"
          />
        </Media>
        <Media at="sm">
          <StaticImage
            src="../images/Titelbild_Downloads_PC.jpeg"
            quality={95}
            formats={["auto", "webp", "avif"]}
            alt="Image"
            objectFit="contain"
            layout="fullWidth"
          />
        </Media>
      </PageImage>

      <PageSection>
        <ContentDiv>
          <DownloadList files={documents} />
        </ContentDiv>
      </PageSection>
    </Layout>
  )
}

// Gatsby Head API - modern way to manage document head
export const Head = () => {
  const seoData = SEO({ lang: "de", title: "Downloads" })
  
  return (
    <>
      <html lang={seoData.lang} />
      <title>{seoData.titleTemplate ? seoData.titleTemplate.replace('%s', seoData.title) : seoData.title}</title>
      {seoData.meta.map((meta, index) => (
        <meta key={index} name={meta.name} property={meta.property} content={meta.content} />
      ))}
    </>
  )
}

export default Downloads
